import React from 'react';
import { Box } from '@chakra-ui/react';
import { HStack } from '@ayble-health/dashboard-components';
import type { RiskLevel } from '../../../models/user';

const LEVEL_CONFIG: Record<RiskLevel, { count: number; color: string }> = {
  Low: { count: 1, color: 'grass' },
  Moderate: { count: 2, color: 'orange' },
  High: { count: 3, color: 'tomato' },
};

type Props = {
  level: RiskLevel | null;
};

/**
 * Three-square risk indicator — 1 green square = Low, 2 amber
 * squares = Moderate, 3 red squares = High. Unfilled squares render
 * as an outline.
 *
 * @example
 * <RiskSquares level={'High'} />
 */
export const RiskSquares = ({ level }: Props) => {
  const config = level ? LEVEL_CONFIG[level] : null;

  return (
    <HStack gap={1} alignItems={'center'}>
      {[0, 1, 2].map((i) => {
        const filled = !!config && i < config.count;

        return (
          <Box
            key={i}
            bg={filled ? config.color : 'transparent'}
            borderColor={filled ? config.color : 'steel'}
            borderRadius={'2px'}
            borderWidth={'1.5px'}
            boxSize={'8px'}
          />
        );
      })}
    </HStack>
  );
};

export default RiskSquares;
